import {
  FormControl,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeData, NodeType } from "../../../models/nodeType";
import { FlowNodeWithChildren } from "./FlowNode";

interface Delay extends NodeData {
  delayInSeconds: number;
}

const DelayNode: React.FC<NodeProps<NodeType<Delay>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const delayInSeconds = nodeData?.delayInSeconds ?? 0;

  const { register, handleSubmit } = useForm<Delay>({
    defaultValues: useMemo(() => ({ delayInSeconds }), [delayInSeconds]),
    mode: "onChange",
  });

  const { updateNodeData } = useUpdateNodeData<Delay>(nodeId);

  const handleUpdate = useCallback(
    (nodeData: Delay) => {
      updateNodeData(nodeData);
    },
    [updateNodeData]
  );

  return (
    <FlowNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
        <Stack>
          <FormControl>
            <FormLabel>
              <Text color={color} casing={"uppercase"}>
                Delay (seconds)
              </Text>
            </FormLabel>
            <NumberInput isRequired step={0.1} defaultValue={0} min={0}>
              <NumberInputField
                id={"delayInSeconds"}
                {...register("delayInSeconds", { valueAsNumber: true })}
                color={color}
              />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>
        </Stack>
      </form>
    </FlowNodeWithChildren>
  );
};

export default memo(DelayNode);
